import appStore from '../utils/state';
import type SizeSelectorForm from './size-selector-form';

export default class SizeSelectorButton extends HTMLElement {
  private button: HTMLButtonElement | null = null;

  private onClickBound = this.onClick.bind(this);
  private onKeyDownBound = () => this.button?.removeAttribute('data-pointer-focus');

  constructor() {
    super();
  }

  connectedCallback(): void {
    this.button = this.querySelector('[data-size-selector-button-ref="button"]');

    this.addEventListeners();
  }

  addEventListeners(): void {
    document.addEventListener('keydown', this.onKeyDownBound);
    if (this.button) {
      this.button.addEventListener('click', this.onClickBound);
    }
  }

  removeEventListeners(): void {
    document.removeEventListener('keydown', this.onKeyDownBound);
    if (this.button) {
      this.button.removeEventListener('click', this.onClickBound);
    }
  }

  onClick(event: MouseEvent): void {
    // iOS can keep :focus-visible after a dialog closes, even following a touch.
    this.button?.toggleAttribute('data-pointer-focus', event.detail > 0);
    // Safari does not focus buttons on pointer clicks; remember the actual opener.
    this.button?.focus({ preventScroll: true });

    if (this.hasAttribute('data-add-selected-variant')) {
      const selector = this.closest('.main-product')?.querySelector<SizeSelectorForm>('size-selector-form');
      if (selector?.selectedVariant?.available) {
        selector.onFormSubmit(event, selector.selectedVariant);
        return;
      }
    }

    appStore.actions.openSizeSelectorModal();
  }

  disconnectedCallback(): void {
    this.removeEventListeners();
  }
}

customElements.define('size-selector-button', SizeSelectorButton);
